import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Table } from "react-bootstrap";
import { Store } from "react-notifications-component";
import PermissionContext from "../../../Store/permission-context";
import axios from "axios";

const DebtPaymentHistoryModal = (props) => {
  const [AxiosError, setAxiosError] = useState("");
  const PCtx = useContext(PermissionContext);
  const [ShowModal, setShowModal] = useState(props.showhistorymodal);
  const [PHTotal, setPHTotal] = useState(0);
  const [PaymentHistory, setPaymentHistory] = useState(props.PaymentHistory);

  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);
  // const [NowPaying, setNowPaying] = useState(0);
  // const [PaymentMode, setPaymentMode] = useState("");

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  const deletePaymentHistory = async (phis) => {
    phis = { ...phis, Username: PCtx.Username };
    const PHistory = await PCtx.connectAxios("deletepaymenthistory.php", phis);
    if (!PHistory.includes("Error")) {
      let pH = [...PaymentHistory];
      pH = pH.filter((k) => k.PID != phis.PID);
      setPaymentHistory(pH);
    }
  };

  useEffect(() => {
    let pH = [...PaymentHistory];
    let pHSum = 0;
    for (var t = 0; t < pH.length; t++) {
      let JJ = { ...pH[t] };
      pHSum += parseFloat(JJ.AmountPaid);
    }

    setPHTotal(pHSum);
  }, [PaymentHistory]);

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={cancelM}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header style={successBackStyle} closeButton>
          <Modal.Title style={{ color: "brown" }}>{}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Row>
            <Col md={12} sm={12} xs={12}>
              <Row className="justify-content-around">
                <Col md={12} sm={12} xs={12}>
                  <Table striped bordered responsive>
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>DATE OF TRANSACTION</th>
                        <th>RECEIPT NUMBER</th>
                        <th>AMOUNT PAID</th>
                        <th>PAYMENT MODE</th>
                        <th>STAFF</th>
                        <th>DELETE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {PaymentHistory.map((rct, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td className="text-center">{rct.DatePaid}</td>
                          <td className="text-center">{rct.PID}</td>
                          <td className="text-center">{rct.AmountPaid}</td>
                          <td className="text-center">{rct.PaymentMode}</td>
                          <td className="text-center">{rct.Staff}</td>
                          <td className="text-center">
                            <Button
                              variant="danger"
                              className="btn btn-xs text-center"
                              onClick={() => deletePaymentHistory(rct)}
                            >
                              -
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
                <Col md={12} sm={12} xs={12}>
                  <h5 className="h5 text-center">Total Paid : {PHTotal}</h5>
                </Col>
                <Col md={4} sm={4} xs={4}>
                  <Button variant="success" className="btn" onClick={cancelM}>
                    Close
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  );
};

export default DebtPaymentHistoryModal;
